<template>
  <div id="app">
    <top-bar :is-transparent="isTopBarTransparent" style="height: 60px"></top-bar>
    <router-view class="main-content"></router-view>
    <bottom-bar></bottom-bar>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue';
import BottomBar from '@/components/BottomBar.vue';

export default {
  name: 'App',
  components: {
    TopBar,
    BottomBar
  },
  data() {
    return {
      isTopBarTransparent: false,
    };
  },
  watch: {
    '$route'(to) {
      // 初始化透明状态基于路由 meta
      this.isTopBarTransparent = to.meta.transparent || false;
    },
  },
  mounted() {
    // 设置初始透明状态
    this.isTopBarTransparent = this.$route.meta.transparent || false;
    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 当滚动距离超过 50px 时，导航栏变为白色
      this.isTopBarTransparent = window.scrollY <= 50 && (this.$route.meta.transparent || false);
    }
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.main-content{
  margin-top: 60px;
}
</style>